import styled, {css} from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";
import {IJackpotBetWidgetBgBoxProps} from "./jackpot-bet-widget-bg.box";
import {baseColors} from "../../../../themes/definitions/mrgreen/base-colors";

export const JackpotBetWidgetBgMRGBox = styled.div<IJackpotBetWidgetBgBoxProps>`
  height: 35rem;
  
  box-shadow: 0px -1px 24px 8px ${baseColors.base01Contrast} inset, 0px 0px 4px 0px ${baseColors.base02} inset;
  border-radius: 10px;


  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        flex-direction: row;
        align-items: center;
    `}

  background-image:
  url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_curtains_bg_png.toString()}),
  linear-gradient(177.59deg, #015536 12.03%, #05372C 27.06%, #05372C 37.9%);

  background-blend-mode: soft-light;
  background-size: 230%;
  background-repeat: no-repeat, no-repeat;
  background-position-y: 10%;
  background-position-x: 48%;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    background-size: 260%;
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    height: 50vh;
    background-size: 240%;
  }

`;
